<app-social-post-details
  [deliverableForm]="deliverableForm()"
  [deliverableId]="deliverableId()"
  [deliverableType]="deliverableType()"
  [executionAnalytics]="executionAnalytics()"
  [platformFeature]="platformFeature()"
  [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
>
  <ng-content />
</app-social-post-details>
